import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import "../../../statusIcon.css";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import "../InterventionListDetail.css";
import { loadIntervention } from "../../../redux/intervention/extranetInterventionActions";
import { formatStatus, getColorFromStatusLabel } from "../../../redux/intervention/extranetInterventionStatus";
import InterventionStatusIcon from "./InterventionStatusIcon";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { Icon } from "@material-ui/core";
import ComponentsParkIcon from "../../../images/components_park_green.png";

const styles = {
	cardActions: {
		padding: 1,
		width: "100%",
		display: "flex",
		flexDirection: "row-reverse",
		justifyContent: "space-between",
		marginTop: "10px",
		paddingLeft: "15px",
	},
	smallButton: {
		width: "130px",
		margin: "0 20px 0 0",
		padding: 0,
	},
	icon: {
		fontSize: 18,
	},
	btnGo: {
		maxHeight: "35px",
	},
};

class InterventionListDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			startInterventionModalOpenned: false,
		};
	}

	displayIntervention() {
		this.props.loadIntervention(this.props.intervention, this.props.activeUser);
		this.props.history.push("/interventions/intervention");
		this.props.globalStore.container.current.scrollTop = 0
	}

	start() {
		if (this.state.startInterventionModalOpenned) {
			this.props.startIntervention(
				this.props.intervention,
				this.props.activeUser,
				this.props.history
			);
			
			this.setState({
				startInterventionModalOpenned: false,
			});

			this.displayIntervention();
		} else {
			this.setState({
				startInterventionModalOpenned: true,
			});
		}
	}

	closeStartInterventionModal() {
		this.setState({
			startInterventionModalOpenned: false,
		});
	}

	render() {
		console.perfLog(getCurrentFunctionName());

		return (
			<div className="col-lg-4 col-md-4 col-sm-6 col-12 div-card">
				<div ref={(divRef) => (this.divRef = divRef)}>
					<Card className="col-lg-12 col-md-12 col-sm-12 col-12 card list-detail-card card-margin-top without-side-padding">
						<CardContent
							className="without-padding card-content-left-align"
							onClick={this.displayIntervention.bind(this)}
						>
							<div>
								<div className="row card-body-margin">
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
										<div className="span-center">
											<span>
												{this.props.intervention.date_planned_start.format(
													"DD/MM/YYYY"
												)}
											</span>
											<span className="bold">
												{" " +
													this.props.intervention.date_planned_start.format(
														"HH:mm"
													)}
											</span>
										</div>
									</div>
									<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding row">
										<div className="span-center bold">
											<div className="row">
												<InterventionStatusIcon state={this.props.intervention.state} />
												<span className={"status-icon-color-" + getColorFromStatusLabel(this.props.intervention.state)} >
													{formatStatus(this.props.intervention.state)}
												</span>
											</div>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding span-center-verticaly card-div-border-right">
											<div className="span-center">
												<span className="bold">
													{this.props.intervention.name ? this.props.intervention.name : ""}
												</span>
											</div>
										</div>
										<div className="col-lg-6 col-md-6 col-sm-6 col-6 without-side-padding">
											<div className="span-center bold">
												<span>{this.props.intervention.allocation_label}</span>
											</div>
										</div>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row intervention-card-others-div">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-2 col-md-2 col-sm-2 col-2">
											<img
												src={ComponentsParkIcon}
												alt=""
												width="18px"
												height="18px"
											/>
										</div>
										<span>
											{this.props.intervention.equipment_description
												? this.props.intervention.equipment_description
												: ""}
										</span>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12 row intervention-card-others-div">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<div className="col-lg-2 col-md-2 col-sm-2 col-2">
											<Icon color="secondary" style={{fontSize: 18}}>
												build
											</Icon>
										</div>
										<span>
											{this.props.intervention.failure_description
												? this.props.intervention.failure_description
												: ""}
										</span>
									</div>
									<div className="col-lg-12 col-md-12 col-sm-12 col-12">
										<div className="col-lg-12 col-md-12 col-sm-12 col-12 row card-divider-div"></div>
										<span className="row intervention-card-technicians-div">
											{this.props.intervention.technicians}
										</span>
									</div>
								</div>
							</div>
						</CardContent>
					</Card>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		interventions: state.interventions,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		loadIntervention: (intervention, user) => dispatch(loadIntervention(intervention, user)),
	};
};

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(InterventionListDetail);
